/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionRiskScore {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionRiskScore.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionRiskScore>): AppSecopsSbomVersionRiskScore {
        let obj = Object.assign(new AppSecopsSbomVersionRiskScore(), model);
        AppSecopsSbomVersionRiskScore.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionRiskScore>): AppSecopsSbomVersionRiskScore {
        if (!model) return null;
        return AppSecopsSbomVersionRiskScore.newInstance(<AppSecopsSbomVersionRiskScore> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionRiskScore) {
        if (!obj) return;

        models.AppSecopsSbomVersionRiskScore.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionRiskScore): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionRiskScore.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.overall_risk_score === undefined) {
            this.overall_risk_score = 0;
        }
    }

    /**
     * The unique ID of the application that the SBOM project is linked to.
     */
    application_id: string;

    /**
     * Aggregated risk score representing the overall impact of the vulnerability, considering multiple risk factors.
     */
    overall_risk_score: number;

}
